import dayjs from "dayjs";
import { exportRecordsToExcel } from "../../../../utils/excelExport";

const USER_TYPE_LABELS = {
    1: "Super Admin",
    2: "User",
    3: "Admin",
    4: "Manager",
    7: "User",
};

const formatTimestamp = (val) => {
    const ts = parseInt(val, 10);
    if (!ts) return "";
    return new Intl.DateTimeFormat("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    }).format(new Date(ts * 1000));
};

const formatDateOnly = (val) => {
    const ts = parseInt(val, 10);
    if (!ts) return "";
    return new Intl.DateTimeFormat("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }).format(new Date(ts * 1000));
};

const formatConnectionStatus = (val) => (val === 1 ? "Connected" : "Not Connected");

const formatOnboardedStatus = (val) => {
    const formatted = formatTimestamp(val);
    return formatted || "In Progress";
};

const formatRemainingDays = (trialExpiresAt) => {
    const ts = parseInt(trialExpiresAt, 10);
    if (!ts) return "";
    const days = Math.ceil((ts * 1000 - Date.now()) / (1000 * 60 * 60 * 24));
    if (days < 0) return `Expired (${Math.abs(days)} day${Math.abs(days) !== 1 ? "s" : ""} ago)`;
    if (days === 0) return "Expires Today";
    return `${days} day${days !== 1 ? "s" : ""}`;
};

export const USER_LIST_EXPORT_COLUMNS = [
    { header: "S.No.", width: 8, getValue: (_, index) => index + 1 },
    { header: "Name", key: "name", width: 22 },
    { header: "Email", key: "email", width: 28 },
    { header: "Seller Name", width: 20, getValue: (record) => record.seller_name || "-" },
    { header: "Contact No.", width: 16, getValue: (record) => record.contact_no || "N/A" },
    {
        header: "User Type",
        width: 14,
        getValue: (record) => USER_TYPE_LABELS[record.user_type] || record.user_type || "-",
    },
    {
        header: "SP API",
        width: 14,
        getValue: (record) => formatConnectionStatus(record.is_amz_sp_api_connected),
    },
    {
        header: "Ads API",
        width: 14,
        getValue: (record) => formatConnectionStatus(record.is_amz_ads_connected),
    },
    {
        header: "Onboarded At",
        width: 22,
        getValue: (record) => formatOnboardedStatus(record.is_data_sync_email_sent),
    },
    {
        header: "Trial Expires At",
        width: 16,
        getValue: (record) => formatDateOnly(record.trial_expires_at) || "-",
    },
    {
        header: "Last Login At",
        width: 22,
        getValue: (record) => formatTimestamp(record.last_login_at) || "-",
    },
    {
        header: "Remaining Days",
        width: 18,
        getValue: (record) => formatRemainingDays(record.trial_expires_at) || "-",
    },
    {
        header: "Created At",
        width: 22,
        getValue: (record) => formatTimestamp(record.created_at) || "-",
    },
    {
        header: "Updated At",
        width: 22,
        getValue: (record) => formatTimestamp(record.updated_at) || "-",
    },
];

export const exportUserListToExcel = (users) => {
    const exportedAt = dayjs();
    const fileName = `Users_List_${exportedAt.format("DD-MM-YYYY_HHmm")}.xlsx`;

    return exportRecordsToExcel({
        records: users,
        columns: USER_LIST_EXPORT_COLUMNS,
        fileName,
        sheetName: "Users",
        summaryRows: [
            { label: "Report", value: "Users List Export" },
            { label: "Exported On", value: exportedAt.format("DD/MM/YYYY hh:mm A") },
            { label: "Total Users", value: users.length },
        ],
    });
};
